export const AdminRoles = ['bia_admin_1', 'bia_admin_2', 'bia_admin_3'];
